/**
 * Obtiene el estado actual del marcador desde la base de datos.
 * @returns {Promise<{success: boolean, data?: any, message?: string}>}
 */
const GetScoreState = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "score/state", {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { success: false, message: errorData.message || 'No ha sido posible obtener el marcador actual.' };
        }
        
        const responseData = await response.json();
        return { success: true, data: responseData.data };
    } catch (error) {
        return { success: false, message: 'Error de conexión. Revisa tu internet e inténtalo de nuevo.' };
    }
};

/**
 * Actualiza los valores lógicos del marcador (goles, tiempo, periodos).
 * @param {Object} dataPayload - { homeScore, awayScore, timerSeconds, isTimerRunning, addedTime, periodName, homeTeamName, awayTeamName }
 * @returns {Promise<{success: boolean, data?: any, message?: string}>}
 */
const UpdateScore = async (dataPayload) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "score/update", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataPayload)
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { success: false, message: errorData.message || 'No ha sido posible actualizar el marcador.' };
        }
        
        const responseData = await response.json();
        return { success: true, data: responseData.data };
    } catch (error) {
        return { success: false, message: 'Error de conexión. Revisa tu internet e inténtalo de nuevo.' };
    }
};

/**
 * Actualiza los estilos visuales del marcador (escala, colores).
 * @param {Object} dataPayload - { scale, backgroundColor, showSponsor }
 * @returns {Promise<{success: boolean, data?: any, message?: string}>}
 */
const UpdateScoreStyle = async (dataPayload) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "score/style", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataPayload)
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { success: false, message: errorData.message || 'No ha sido posible actualizar los estilos visuales.' };
        }
        
        const responseData = await response.json();
        return { success: true, data: responseData.data };
    } catch (error) {
        return { success: false, message: 'Error de conexión. Revisa tu internet e inténtalo de nuevo.' };
    }
};

/**
 * Dispara una notificación efímera en la pantalla (Gol, Tarjeta, Cambio).
 * @param {Object} dataPayload - { type, htmlContent, durationSeconds }
 * @returns {Promise<{success: boolean, data?: any, message?: string}>}
 */
const TriggerScoreNotification = async (dataPayload) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "score/notification", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataPayload)
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { success: false, message: errorData.message || 'No ha sido posible enviar la notificación.' };
        }
        
        // Es un Accepted (202), puede que no traiga un objeto 'data' complejo
        const responseData = await response.json();
        return { success: true, data: responseData };
    } catch (error) {
        return { success: false, message: 'Error de conexión al enviar la notificación.' };
    }
};

export { GetScoreState, UpdateScore, UpdateScoreStyle, TriggerScoreNotification };